import { render, staticRenderFns } from "./position-bar.vue?vue&type=template&id=3246c1f2"
import script from "./position-bar.vue?vue&type=script&lang=js"
export * from "./position-bar.vue?vue&type=script&lang=js"
import style0 from "./position-bar.vue?vue&type=style&index=0&id=3246c1f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports